/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * Корневая папка документов пользователя, привязанная к бизнес-сущности (заявке или запросу на товарный знак)
 * @export
 * @interface UserDocumentFolder
 */
export interface UserDocumentFolder {
  /**
   * UUID папки
   * @type {string}
   * @memberof UserDocumentFolder
   */
  uuid: string
  /**
   * Название папки
   * @type {string}
   * @memberof UserDocumentFolder
   */
  name: string
  /**
   * Тип бизнес-сущности — владелец папки (SysObject)
   * @type {string}
   * @memberof UserDocumentFolder
   */
  type: UserDocumentFolderTypeEnum | null
  /**
   * Дата последнего изменения: максимум из updated_at дочерних документов либо самой папки
   * @type {string}
   * @memberof UserDocumentFolder
   */
  updatedAt: string
}

/**
 * @export
 * @enum {string}
 */
export enum UserDocumentFolderTypeEnum {
  Applications = 'applications',
  TrademarkRequests = 'trademark_requests',
}

/**
 * Check if a given object implements the UserDocumentFolder interface.
 */
export function instanceOfUserDocumentFolder(
  value: object
): value is UserDocumentFolder {
  if (!('uuid' in value) || value['uuid'] === undefined) return false
  if (!('name' in value) || value['name'] === undefined) return false
  if (!('type' in value) || value['type'] === undefined) return false
  if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false
  return true
}

export function UserDocumentFolderFromJSON(json: any): UserDocumentFolder {
  return UserDocumentFolderFromJSONTyped(json, false)
}

export function UserDocumentFolderFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UserDocumentFolder {
  if (json == null) {
    return json
  }
  return {
    uuid: json['uuid'],
    name: json['name'],
    type: json['type'],
    updatedAt: json['updatedAt'],
  }
}

export function UserDocumentFolderToJSON(
  value?: UserDocumentFolder | null
): any {
  if (value == null) {
    return value
  }
  return {
    uuid: value['uuid'],
    name: value['name'],
    type: value['type'],
    updatedAt: value['updatedAt'],
  }
}
